/**
 * Shared MUI `sx` styles for ManualTestDialog and AutoTestDialog (labels, outlined fields, topic chips).
 */

/** Uppercase label above fields. */
export const testDialogFieldLabelSx = {
  display: 'block',
  fontSize: '0.68rem',
  fontWeight: 700,
  letterSpacing: '0.07em',
  textTransform: 'uppercase',
  color: 'primary.dark',
  mb: 0.5,
  lineHeight: 1.2,
};

/** Soft rounded inputs with a light blue wash in light mode. */
export const testDialogFieldShellSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    bgcolor: (t) =>
      t.palette.mode === 'light' ? 'rgba(25, 118, 210, 0.07)' : 'action.hover',
    transition: 'border-color 0.15s, box-shadow 0.15s',
    '&:hover': {
      bgcolor: (t) =>
        t.palette.mode === 'light' ? 'rgba(25, 118, 210, 0.1)' : 'action.selected',
    },
    '&.Mui-focused': {
      boxShadow: (t) =>
        `0 0 0 3px ${t.palette.mode === 'light' ? 'rgba(25, 118, 210, 0.18)' : 'rgba(144, 202, 249, 0.2)'}`,
    },
  },
};

/** Topic tags in multi-select Autocomplete. */
export const testDialogTopicChipSx = {
  borderRadius: 2,
  height: 28,
  fontWeight: 600,
  bgcolor: (t) =>
    t.palette.mode === 'light' ? 'rgba(25, 118, 210, 0.14)' : 'primary.dark',
  color: 'primary.dark',
  border: '1px solid',
  borderColor: (t) =>
    t.palette.mode === 'light' ? 'rgba(25, 118, 210, 0.35)' : 'primary.light',
  '& .MuiChip-deleteIcon': {
    color: 'primary.main',
    '&:hover': { color: 'primary.dark' },
  },
};
